import { Loading } from 'pages/loading';
import React, { Suspense } from 'react';
import { useOnboardingAnswersQuery } from 'shared/hooks/queries/use-onboarding-answers-query';
import { useUpdateOnboardingAnswersMutation } from 'shared/hooks/queries/use-update-onboarding-answers-mutation';
import { OnboardingSteps } from 'shared/types/onboarding-answers';
import { OnboardingQuestions } from 'shared/views/onboarding-questions';

import { CreateAccount } from './components/create-account';

const SignupContent: React.FC = () => {
  const { mutate: updateAnswers } = useUpdateOnboardingAnswersMutation();
  const { data: answers } = useOnboardingAnswersQuery();

  const onFinishQuestions = () =>
    updateAnswers({ lastShownStep: OnboardingSteps.CreateAccount });

  if (answers?.lastShownStep === OnboardingSteps.CreateAccount) {
    return <CreateAccount />;
  }

  return <OnboardingQuestions onFinish={onFinishQuestions} />;
};

export const Signup: React.FC = () => (
  <Suspense fallback={<Loading />}>
    <SignupContent />
  </Suspense>
);
